// extracted by mini-css-extract-plugin
module.exports = {"SelectedList":"SelectedList__SelectedList__316zc"};